var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSavedOn = function SvgIconSavedOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 5.6A2.6 2.6 0 0 1 12.6 3h23.3a2.6 2.6 0 0 1 2.6 2.6v36.003c0 1.138-1.358 1.727-2.188.95l-10.94-10.236a1.3 1.3 0 0 0-1.759-.016L12.172 42.638c-.837.756-2.172.162-2.172-.965z"
  })));
};
export default SvgIconSavedOn;